import React from 'react';
import { XCircleIcon } from '@heroicons/react/24/outline';

const DownloadPromptModal = ({ onClose, onRegister, onSubscribe }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm transition-opacity duration-300">
      <div className="relative bg-white w-full max-w-md mx-4 rounded-2xl shadow-2xl p-6 text-center animate-fade-in-down">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition"
          aria-label="Close"
        >
          <XCircleIcon className="h-6 w-6" />
        </button>
        <div className="mb-4">
          <svg className="mx-auto h-12 w-12 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h2 className="text-2xl font-semibold text-gray-800 mb-2">You're Almost There!</h2>
        <p className="text-sm text-gray-600 mb-6">
          Register as a Choir Member and enjoy 1 free download each month. <br /><br />
          For unlimited downloads, become a <b>Choir Supporter</b> (1 month) or <b>Choir Expert</b> (1 year) and help us sustain Choir Center!
        </p>
        <div className="flex justify-center gap-4">
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-full transition"
            onClick={onRegister}
          >
            Register
          </button>
          <button
            className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-full transition"
            onClick={onSubscribe}
          >
            Subscribe
          </button>
        </div>
      </div>
    </div>
  );
};

export default DownloadPromptModal;
